"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault"),
    _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: !0
}), exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react")),
    _classnames = _interopRequireDefault(require("classnames")),
    _Image = _interopRequireDefault(require("../../Image")),
    _onEnterPressed = _interopRequireDefault(require("../../../common/utils/onEnterPressed")),
    _imageCard = require("../styles/imageCard");

function ImageCard(a) {
  var b = a.imageUrl,
      c = a.width,
      d = a.height,
      e = a.title,
      f = a.subtitle,
      g = a.onClick;
  return _react["default"].createElement("div", {
    className: (0, _classnames["default"])("image-card", (0, _imageCard.IMAGE_CARD)(c, d)),
    tabIndex: 0,
    role: "button",
    onClick: g,
    onKeyDown: (0, _onEnterPressed["default"])({
      onClick: g
    })
  }, b ? _react["default"].createElement(_Image["default"], {
    width: "100%",
    height: "100%",
    imageUrl: b,
    backgroundSize: "cover"
  }) : _react["default"].createElement("div", {
    className: (0, _classnames["default"])("image-card-empty", _imageCard.IMAGE_CARD_EMPTY)
  }), _react["default"].createElement("div", {
    className: (0, _classnames["default"])("image-card__child", _imageCard.IMAGE_CARD_CHILD)
  }, e && _react["default"].createElement("p", {
    className: "title"
  }, e), f && _react["default"].createElement("p", {
    className: "sub-title"
  }, f)));
}

ImageCard.defaultProps = {
  width: "300px",
  height: "150px",
  imageUrl: void 0,
  title: void 0,
  subtitle: void 0
};

var _default = (0, _react.memo)(ImageCard);

exports["default"] = _default;